/**
 * Fatiado de ReviewPanel.tsx (revisão UX 5640787646 + limite de linhas, QA
 * 5640804090 r.3): taxa de serviço/coperto lida no Menu (#321) — sugerida
 * como informação, nunca cobrança. Formatação com Intl na moeda do import
 * e «pessoa/conta» na língua do painel.
 *
 * #486 (item 4): o locale do Intl é composto com o PAÍS do restaurante
 * (`intlLocaleFor(lang, país)`, a regra do resto do painel —
 * MenuThemePreview) — painel pt + PT vê «2,50 €», + BR vê «R$ 3,50». A
 * percentagem também sai do Intl (style: 'percent').
 */
import { useI18n } from '../../lib/i18n.js'
import { intlLocaleFor } from '@self-restaurant/shared'
import type { ImportDraft } from '../../lib/api.js'

export function ReviewServiceCharge({
  charges,
  currency,
  country,
}: {
  charges: ImportDraft['service_charges']
  /** moeda do import (restaurante, decisão B) — base da formatação Intl */
  currency: string | null | undefined
  /** #486: país do restaurante (view.restaurant_country) — região do locale */
  country?: string | null
}) {
  const { t, lang } = useI18n()
  if (!charges || charges.length === 0) return null
  const intlLocale = intlLocaleFor(lang || 'pt', country ?? null)
  const fmt = new Intl.NumberFormat(intlLocale, {
    style: 'currency',
    currency: currency || 'EUR',
  })
  const pct = new Intl.NumberFormat(intlLocale, { style: 'percent' })
  return (
    <div
      data-testid="import-review-service-charge"
      className="text-[11px] text-sky-800 bg-sky-50 border border-sky-100 rounded-lg px-3 py-2"
    >
      {t('admin.import.service_charge_found', {
        charge: charges
          .map((sc) =>
            sc.amount_cents !== undefined
              ? `${sc.label ?? ''} ${fmt.format(sc.amount_cents / 100)}/${t(
                  sc.per === 'person'
                    ? 'admin.import.service_per_person'
                    : 'admin.import.service_per_bill',
                )}`
              : `${sc.label ?? ''} ${pct.format((sc.percent ?? 0) / 100)}`,
          )
          .join(' · '),
      })}
    </div>
  )
}
